import { Box, Button, Grid2, IconButton, MenuItem, Paper, Select, Snackbar, TextField, Typography } from "@mui/material";
import Navbar from "../navbar/Navbar";
import Sidemenu from "../sidemenu/Sidemenu";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import React, { useEffect, useState } from "react";
import CommonGeofence from "../geofence/CommonGeofence.jsx";
import constants from '../../constant.js'
import CloseIcon from '@mui/icons-material/Close';
import { Label } from "flowbite-react";
import { use } from "react";
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import utc from 'dayjs/plugin/utc';
import TokenError from "../tokenError";
import { GoogleMap, Polygon, useJsApiLoader } from "@react-google-maps/api";
import { useNavigate } from "react-router-dom";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);
dayjs.extend(utc);

const LIBRARIES = ["maps", "drawing", "places", "geometry"];

const SurgePricing = (cityObj) => {
    const today = dayjs();
    // console.log(today, 'today==')
    const date = dayjs().utc();
    // console.log('today date is ',date.toISOString()); 
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [city, setCity] = useState(cities[0]);
    const [surgeData, setSurgeData] = useState([]);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);

    const [surgeName, setSurgeName] = useState('');
    const [vehicleType, setVehicleType] = useState("");
    const [activeStatus, setActiveStatus] = useState('Active');
    const [startDate, setStartDate] = useState(dayjs());
    const [endDate, setEndDate] = useState(dayjs());
    const [startTime, setStartTime] = useState(date);
    const [endTime, setEndTime] = useState(date);
    const [customerFare, setCustomerFare] = useState('');
    const [driverFare, setDriverFare] = useState('');
    const [priority, setPriority] = useState('');
    const [surgeId, setSurgeId] = useState(0);
    const cityGeo = city ? city.geofence[0] : '';
    const [surgeGeofence, setSurgeGeofence] = useState(cityGeo);
    const [weekDaysData, setWeekDaysData] = useState('');
    const [vehicleClient, setVehicleClient] = useState('');
    const [polyPath, setPolyPath] = useState([]);
    const [mapInstance, setMapInstance] = useState(null);
    const [bound, setBound] = useState(false);
    const [callDeleteAPI, setCallDeleteAPI] = useState(false);

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (mapInstance&& surgeGeofence && surgeGeofence.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            surgeGeofence.forEach((point) =>
                bounds.extend({ lat: point.x, lng: point.y })
            );
            mapInstance.fitBounds(bounds);
        }
    }, [surgeGeofence, bound]);

    // console.log('startTime == ', startTime)

    const WeekdaysConst = constants.WeekdaysConst;
    const weekdaysArray = [
        { name: 'Sun', value: WeekdaysConst.SUN },
        { name: 'Mon', value: WeekdaysConst.MON },
        { name: 'Tue', value: WeekdaysConst.TUE },
        { name: 'Wed', value: WeekdaysConst.WED },
        { name: 'Thu', value: WeekdaysConst.THUR },
        { name: 'Fri', value: WeekdaysConst.FRI },
        { name: 'Sat', value: WeekdaysConst.SAT },
    ];

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
        setCity(city);
        const geoo = city ? city.geofence[0] : '';
        setSurgeGeofence(geoo);
    }

    const handleUpdatePolygon = (polygonPath) => {
        // console.log("Updated polygon path received from child:", polygonPath);
        // Handle the updated polygon path here, e.g., save to an API
        setPolyPath(polygonPath);

        // setSurgeGeofence(polygonPath);
    };

    const fetchSurgePricingData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/pricing/fetch_all';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setSurgeData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const fetchVehicleClient = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/vehicle/get_client_vehicles';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // Filter active vehicles
                const activeVehicles = response.data.filter(vehicle => vehicle.is_active === 1);
                setVehicleClient(activeVehicles);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(() => {
        fetchSurgePricingData();
        fetchVehicleClient();
    }, [cityFilter]);

    const handleGridClick = (data) => {

        const city =  cities.find((cityObj) => cityObj.city_id === data.city_id)
        const geo = data.geofence ? data.geofence[0] : (city ? city.geofence[0] : '');
        setSurgeGeofence(geo);
    }
    const handleOpenAddModal = () =>{
        setOpenAddModal(true);
        setOpenEditModal(false);
        setSurgeName('');
        setActiveStatus('Active');
        setVehicleType('');
        setStartDate(dayjs());
        setEndDate(dayjs());
        setStartTime(date);
        setEndTime(date);
        setCustomerFare('');
        setDriverFare('');
        setPriority('');
        setSurgeGeofence([]);
        setWeekDaysData('');
    }
    const handleOpenEdit = (row) =>{
        console.log("===row-details===", row);
        setSurgeName(row.name);
        setActiveStatus(row.status==1? 'Active': 'Inactive');
        setVehicleType(row.client_vehicle_type_id);
        setStartDate(dayjs(row.start_date));
        setEndDate(dayjs(row.end_date));

        // Explicitly parse `start_time` and `end_time` in "HH:mm:ss" format
        setStartTime(dayjs(row.start_time, "HH:mm:ss")); 
        setEndTime(dayjs(row.end_time, "HH:mm:ss")); 

        setCustomerFare(row.customer_fare_factor);
        setDriverFare(row.driver_fare_factor);
        setPriority(row.priority);
        setSurgeGeofence(row.geofence ? row.geofence[0] : '');
        setWeekDaysData(row.week_days);
        setOpenEditModal(true);
        setOpenAddModal(false);
        setSurgeId(row.surge_id);
    }
    const handleClose=()=>{
        setOpenEditModal(false);
        setOpenAddModal(false);
    }
    const saveData = async()=>{
        const token = localStorage.getItem('token');

        // Convert `start_time` and `end_time` to 24-hour format
        const formattedStartTime = startTime ? startTime.format("HH:mm:ss") : null; // Ensure 24-hour format
        const formattedEndTime = endTime ? endTime.format("HH:mm:ss") : null;

        const payload = {
            token: token,
            name: surgeName,
            status: activeStatus=="Active" ? 1 : activeStatus=="Inactive" ? 0 : -1,
            start_date: startDate,
            end_date: endDate,
            start_time:  formattedStartTime,
            end_time: formattedEndTime,
            customer_fare_factor: customerFare,
            driver_fare_factor: driverFare,
            client_vehicle_type_id: vehicleType,
            geofence: polyPath? polyPath: surgeGeofence,
            week_days: weekDaysData,
            city_id: cityFilter,
            priority: priority
        }
        if(openEditModal || surgeId!=0){
            payload.surge_id = surgeId;
        }
        try {
            const url = operationsUrl + '/pricing/add_update_surge_pricing';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                console.log('Document saved successfully:', response.message);
                setMessage(response.message)
                showSnackbar(true);

            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                console.error('Failed to save document:', response.message);
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            // setMessage(error);
        }

        handleClose(); // Close the modal after saving
        fetchSurgePricingData();
    }

    const handleCheckboxChange = (event) => {
        const value = String(event.target.value);
        const currentDays = weekDaysData.split(',').filter(Boolean); // Convert string to array

        if (event.target.checked) {
            // Add value and convert back to string
            setWeekDaysData([...currentDays, value].join(','));
        } else {
            // Remove value and convert back to string
            setWeekDaysData(currentDays.filter((day) => day !== value).join(','));
        }
    };

    const loaderOptions = {
        id: 'google-map-script',
        googleMapsApiKey: constants.API_KEY, // Replace with your actual API key
        libraries: LIBRARIES,
    }
    
    const { isLoaded, loadError } = useJsApiLoader(loaderOptions);

    const containerStyle = {
        width: '100%',
        height: '460px',
    };
    const center = {
        lat: surgeGeofence ? surgeGeofence.reduce((sum, point) => sum + point.x, 0) / surgeGeofence.length : 0,
        lng: surgeGeofence ? surgeGeofence.reduce((sum, point) => sum + point.y, 0) / surgeGeofence.length : 0,
    };

    const onLoad = React.useCallback((map) => {
        setMapInstance(map); // Save map instance for later use
    }, []);
    const onUnmount = React.useCallback(function callback(map) {
        setMapInstance(null);
        console.log('unmounting');
    }, []);

    const handleDeleteCard = (row) => {
        setSurgeId(row.surge_id);
        setSurgeName(row.name);
        setActiveStatus(-1);
        setVehicleType(row.client_vehicle_type_id);
        setStartDate(dayjs(row.start_date));
        setEndDate(dayjs(row.end_date));
        setStartTime(dayjs(row.start_time));
        setEndTime(dayjs(row.end_time));
        // setStartTime(date);
        // setEndTime(date);
        setCustomerFare(row.customer_fare_factor);
        setDriverFare(row.driver_fare_factor);
        setPriority(row.priority);
        setSurgeGeofence(row.geofence ? row.geofence[0] : '');
        setWeekDaysData(row.week_days);
        setCallDeleteAPI(true);
    }

    useEffect(() => {
        if(callDeleteAPI === true) {
            saveData();
            setCallDeleteAPI(false);
        }
    }, [callDeleteAPI])

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    return(
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Surge Pricing</Typography>

            <Grid2 item container spacing={2} sx={{marginTop:'2%'}}>
                <Grid2 item>
                    <Select value={cityFilter} onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddModal}
                        style={{width:'190px', height:'50px', backgroundColor:'#000000', textTransform:'none', borderRadius:'8px'}}>
                        + Add Surge
                    </Button>
                </Grid2>
            </Grid2>

            <Grid2 item container size={12} spacing={2} sx={{marginTop:'2%'}}>
                <Grid2 item size={5} sx={{ overflowY:'auto', maxHeight:'580px'}}>
                    {(surgeData).map((data) => {
                        const activeDays = data.week_days.split(',').map(Number);
                        return(
                            <Grid2 item sx={{backgroundColor:'#fff', borderRadius:'12px', padding:'4px', marginBottom:'4%', cursor:'pointer'}} key={data.surge_id} onClick={() => handleGridClick(data)}>
                                <Grid2 item container sx={{padding:'12px'}}>
                                    <Typography>{data.name}</Typography>
                                    <Typography sx={{marginLeft:'auto', backgroundColor: data.status==1?'#0DBA78':'#D14545', color:'#fff', fontSize:'12px',padding:'4px 16px', borderRadius:"6px"}}>
                                        {data.status==1 ? 'Active' : 'Inactive'}
                                    </Typography>
                                </Grid2>
                                {/* <Grid2 item container sx={{backgroundColor:'#F3F8FF', border:'1px solid #96C0FF', borderRadius:'6px', padding:'4px 12px',margin:'0px 8px'}}>
                                    <Typography sx={{color:'#0065FF', fontSize:'14px'}}>By Aniket Kumar | 10 August 2020, 10:30AM</Typography>
                                </Grid2> */}
                                <hr/>
                                <Grid2 item container sx={{margin:'2%'}}>
                                    <Grid2 item><Typography>Start Date & Time</Typography></Grid2>
                                    <Grid2 item sx={{backgroundColor:'#2A313C', borderRadius:'6px', marginLeft:'auto'}}>
                                        <Typography sx={{color:'#FFFFFF', fontSize:'14px', padding:"4px 8px"}}>{data.start_date.split('T')[0]} | {data.start_time}</Typography>
                                    </Grid2>

                                    {/* <Typography>{Date(data.start_time)}</Typography> */}
                                </Grid2>
                                <Grid2 item container sx={{margin:'2%'}}>
                                    <Grid2 item><Typography>End Date & Time</Typography></Grid2>
                                    <Grid2 item sx={{backgroundColor:'#2A313C', borderRadius:'6px', marginLeft:'auto'}}>
                                        <Typography sx={{color:'#FFFFFF', fontSize:'14px', padding:"4px 8px"}}>{data.end_date.split('T')[0]} | {data.end_time}</Typography>
                                    </Grid2>
                                </Grid2>
                                <Grid2 item container sx={{margin:'2%'}}>
                                    <Grid2 item><Typography>Customer Fare Factor</Typography></Grid2>
                                    <Grid2 item sx={{backgroundColor:'#2A313C', borderRadius:'6px', marginLeft:'auto'}}>
                                        <Typography sx={{color:'#FFFFFF', fontSize:'14px', padding:"4px 8px"}}>{data.customer_fare_factor}</Typography>
                                    </Grid2>
                                </Grid2>
                                <Grid2 item container sx={{margin:'2%'}}>
                                    <Grid2 item><Typography>Driver Fare Factor</Typography></Grid2>
                                    <Grid2 item sx={{backgroundColor:'#2A313C', borderRadius:'6px', marginLeft:'auto'}}>
                                        <Typography sx={{color:'#FFFFFF', fontSize:'14px', padding:"4px 8px"}}>{data.driver_fare_factor}</Typography>
                                    </Grid2>
                                </Grid2>
                                <Grid2 item container sx={{margin:'2%'}}>
                                    <Grid2 item><Typography>Priority</Typography></Grid2>
                                    <Grid2 item sx={{backgroundColor:'#2A313C', borderRadius:'6px', marginLeft:'auto'}}>
                                        <Typography sx={{color:'#FFFFFF', fontSize:'14px', padding:"4px 8px"}}>{data.priority}</Typography>
                                    </Grid2>
                                </Grid2>

                                <Grid2 item container spacing={0.6} >
                                    {weekdaysArray.map((weekday) => (
                                        <Grid2 key={weekday.value} item sx={{backgroundColor: activeDays.includes(weekday.value) ? '#0065FF' : '#E0E0E0',
                                        borderRadius: '8px',width: '48px',height: '48px',display: 'flex',alignItems: 'center',justifyContent: 'center', marginLeft:'4px'}}>
                                            <Typography
                                                sx={{
                                                    color: activeDays.includes(weekday.value)
                                                        ? '#FFFFFF' // White text for active days
                                                        : '#A0A0A0', // Grey text for inactive days
                                                    fontWeight:500
                                                }}
                                            >
                                                {weekday.name}
                                            </Typography>
                                        </Grid2>
                                    ))}
                                    {/* <Grid2 item sx={{backgroundColor:'#0065FF', borderRadius:'6px', marginLeft:'8px', width:'52px', height:'52px', display: 'flex', // Set display to flex
                                        alignItems: 'center', justifyContent: 'center'}}>
                                        <Typography sx={{color:'#FFFFFF'}}>Mon</Typography>
                                    </Grid2>
                                    <Grid2 item sx={{backgroundColor:'#0065FF', borderRadius:'6px', marginLeft:'8px', width:'52px', height:'52px', display: 'flex', // Set display to flex
                                        alignItems: 'center', justifyContent: 'center'}}>
                                        <Typography sx={{color:'#FFFFFF'}}>Tue</Typography>
                                    </Grid2> */}
                                </Grid2>

                                <hr/>
                                <Grid2 item container spacing={1.6} sx={{marginBottom:'8px'}}>
                                    <Button sx={{border:'1px solid #C71F1F', width:'180px', marginLeft:'8px'}} onClick={() => handleDeleteCard(data)}>
                                        <Typography sx={{color:'#C71F1F', textTransform:'none'}}>Delete</Typography>
                                    </Button>
                                    <Button variant="contained" sx={{width:'180px', backgroundColor:'#0DBA78'}} onClick={() => handleOpenEdit(data)}>
                                        <Typography sx={{color:'#EFFBF7', textTransform:'none'}}>Edit</Typography>
                                    </Button>
                                </Grid2>
                            </Grid2>
                        )
                    }
                    )}
                    
                </Grid2>

                <Grid2 item size={7}>
                    {/* <CommonGeofence geofence={surgeGeofence} onUpdatePolygon={handleUpdatePolygon} /> */}
                    <Grid2 className='mainBox' sx={{marginTop:'2%'}}>

                        {/* <div>
                            {surgeGeofence ? JSON.stringify(surgeGeofence) : '--'}
                        </div> */}
                        {isLoaded ? (
                            <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={8} onLoad={onLoad} onIdle={()=> { setBound(true)}} onUnmount={onUnmount}>
                                    {/* {console.log("Rendering Polygon...")} */}
                                {surgeGeofence && (
                                    
                                    <Polygon                                   
                                    key={JSON.stringify(surgeGeofence)}
                                        paths={surgeGeofence.map((point) => ({
                                            lat: Number(point.x || point.lat), // Convert x to lat
                                            lng: Number(point.y || point.lng)  // Convert y to lng
                                        }))
                                        .filter((point) => !isNaN(point.lat) && !isNaN(point.lng) && isFinite(point.lat) && isFinite(point.lng))
                                    } 
                                        options={{
                                            fillColor: "rgba(255, 0, 0, 0.3)", // Semi-transparent fill color
                                            fillOpacity: 0.4,
                                            strokeColor: "red",
                                            strokeOpacity: 1,
                                            strokeWeight: 2,
                                        }}
                                    />
                                )}
                            
                            </GoogleMap>
                            
                        
                        ): (<></>)}

                    </Grid2>
                </Grid2>
            </Grid2>

            {(openAddModal || openEditModal) && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '78%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Grid2 item container spacing={2} size={12} sx={{marginLeft:'12px'}}>
                                <Grid2 item size={6} sx={{backgroundColor:'#fff', padding:'12px', borderRadius:'12px', overflowY:'auto',maxHeight: '620px'}}>
                                    <Typography sx={{color:'#4E545D', fontSize:'24px', fontWeight:500}}>New Surge</Typography>
                                    <Grid2 item sx={{marginTop:'4%'}}>
                                        <Label>Surge Name<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'1%'}}
                                            placeholder="Surge Name" fullWidth variant="outlined" type="text" 
                                            value={surgeName}
                                            onChange={(e) => setSurgeName(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '46px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid2>
                                    <Grid2 item sx={{marginTop:'4%'}}>
                                        <Label>Vehicle Type<span style={{ color: 'red' }}>*</span></Label>
                                        {/* <TextField  sx={{marginTop:'1%'}}
                                            placeholder="Vehicle Type" fullWidth variant="outlined" type="text" 
                                            value={vehicleType}
                                            onChange={(e) => setVehicleType(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '46px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        /> */}
                                        <Select sx={{marginTop:'2%'}} fullWidth
                                            value={vehicleType} 
                                            onChange={(e) => setVehicleType( e.target.value)}
                                            style={{ height: '50px', borderRadius: '8px'}}>
                                            <MenuItem value="">Vehicle</MenuItem>
                                            {vehicleClient.map((vehicle) => (
                                                <MenuItem key={vehicle.vehicle_id} value={vehicle.vehicle_id}>
                                                    {vehicle.vehicle_name}
                                                </MenuItem>
                                            ))}
                                            {/* <MenuItem value="Active">Active</MenuItem>
                                            <MenuItem value="Inactive">Inactive</MenuItem> */}
                                        </Select>
                                    </Grid2>
                                    <Grid2 item sx={{marginTop:'4%'}}>
                                        <Label>Week days<span style={{ color: 'red' }}>*</span></Label>
                                        
                                        <FormGroup>
                                            <Grid2 item sx={{display:'flex'}}>
                                                <FormControlLabel control={<Checkbox value={1} checked={weekDaysData.includes(1)} onChange={handleCheckboxChange} />} label="Monday" />
                                                <FormControlLabel control={<Checkbox value={2} checked={weekDaysData.includes(2)} onChange={handleCheckboxChange} />} label="Tuesday" value={2} />
                                                <FormControlLabel control={<Checkbox value={3} checked={weekDaysData.includes(3)} onChange={handleCheckboxChange}/>} label="Wednesday" value={3} />
                                                <FormControlLabel control={<Checkbox value={4} checked={weekDaysData.includes(4)} onChange={handleCheckboxChange} />} label="Thursday" value={4} />
                                                <FormControlLabel control={<Checkbox value={5} checked={weekDaysData.includes(5)} onChange={handleCheckboxChange}/>} label="Friday" value={5} />
                                                <FormControlLabel control={<Checkbox value={6} checked={weekDaysData.includes(6)} onChange={handleCheckboxChange} />} label="Saturday" value={6} />
                                                <FormControlLabel control={<Checkbox value={7} checked={weekDaysData.includes(7)} onChange={handleCheckboxChange} />} label="Sunday" value={7} />
                                            </Grid2>
                                            
                                        </FormGroup>
                                    </Grid2>
                                    <Grid2 item sx={{marginTop:'4%'}}>
                                        <Label>Status<span style={{ color: 'red' }}>*</span></Label>
                                        <Select sx={{marginTop:'2%'}} fullWidth
                                            value={activeStatus} 
                                            onChange={(e) => setActiveStatus( e.target.value)}
                                            style={{ height: '50px', borderRadius: '8px'}}>
                                            {/* <MenuItem value="">Status</MenuItem> */}
                                            <MenuItem value="Active">Active</MenuItem>
                                            <MenuItem value="Inactive">Inactive</MenuItem>
                                        </Select>
                                    </Grid2>
                                    <Grid2
                                        container
                                        spacing={2}
                                        sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            justifyContent: 'space-between',
                                            gap: 2, // Adds consistent spacing between items
                                        }}
                                        >
                                        <Grid2
                                            item
                                            xs={12}
                                            sm={6}
                                            md={3}
                                            sx={{
                                            marginTop: '4%',
                                            }}
                                        >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                label="Start Date"
                                                value={startDate}
                                                onChange={(newValue) => setStartDate(newValue)}
                                                renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    sx={{
                                                    '& .MuiInputBase-root': {
                                                        overflow: 'hidden',
                                                    },
                                                    }}
                                                />
                                                )}
                                            />
                                            </LocalizationProvider>
                                        </Grid2>

                                        <Grid2
                                            item
                                            xs={12}
                                            sm={6}
                                            md={3}
                                            sx={{
                                            marginTop: '4%',
                                            }}
                                        >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                label="End Date"
                                                value={endDate}
                                                onChange={(newValue) => setEndDate(newValue)}
                                                renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    sx={{
                                                    '& .MuiInputBase-root': {
                                                        overflow: 'hidden',
                                                    },
                                                    }}
                                                />
                                                )}
                                            />
                                            </LocalizationProvider>
                                        </Grid2>

                                        <Grid2
                                            item
                                            xs={12}
                                            sm={6}
                                            md={3}
                                            sx={{
                                            marginTop: '4%',
                                            }}
                                        >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <TimePicker
                                                label="Start Time"
                                                value={startTime}
                                                onChange={(newValue) => setStartTime(newValue)}
                                                ampm={false} // Disable AM/PM
                                                renderInput={(params) => <TextField {...params} fullWidth />}
                                            />
                                            </LocalizationProvider>
                                        </Grid2>

                                        <Grid2
                                            item
                                            xs={12}
                                            sm={6}
                                            md={3}
                                            sx={{
                                            marginTop: '4%',
                                            }}
                                        >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <TimePicker
                                                label="End Time"
                                                value={endTime}
                                                onChange={(newValue) => setEndTime(newValue)}
                                                ampm={false} // Disable AM/PM
                                                renderInput={(params) => <TextField {...params} fullWidth />}
                                            />
                                            </LocalizationProvider>
                                        </Grid2>
                                        </Grid2>
                                    <Grid2 item sx={{marginTop:'4%'}}>
                                        <Label>Customer Fare Factor<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'1%'}}
                                            placeholder="Customer Fare Factor" fullWidth variant="outlined" type="text" 
                                            value={customerFare}
                                            onChange={(e) => setCustomerFare(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '46px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid2>
                                
                                    <Grid2 item sx={{marginTop:'4%'}}>
                                        <Label>Driver Fare Factor<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'1%'}}
                                            placeholder="Driver Fare Factor" fullWidth variant="outlined" type="text" 
                                            value={driverFare}
                                            onChange={(e) => setDriverFare(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '46px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid2>

                                    <Grid2 item sx={{marginTop:'4%'}}>
                                        <Label>Priority<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'1%'}}
                                            placeholder="Priority" fullWidth variant="outlined" type="number" 
                                            value={priority}
                                            onChange={(e) => setPriority(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '46px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid2>

                                    <Grid2 container item sx={{marginTop:'6%', justifyContent:'center', marginBottom:'4%'}} spacing={4}>
                                        <Grid2 item>
                                            <Button variant="contained" sx={{backgroundColor:'#0065FF', textTransform:'none', padding:'8px 20px'}} onClick={saveData}>{openAddModal ? 'Create' : 'Update'}</Button>
                                        </Grid2>
                                        <Grid2 item>
                                            <Button variant="contained" sx={{backgroundColor:'#D14545', textTransform:'none', padding:'8px 20px'}} onClick={handleClose}>Cancel</Button>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <Grid2 item size={6}>
                                    <CommonGeofence geofence={surgeGeofence ? surgeGeofence : null} onUpdatePolygon={handleUpdatePolygon} />
                                </Grid2>
                            </Grid2>
                        </div>
                    </Box>
                </div>
            )}

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
                
        </div>
    )
}

export default SurgePricing;